import {
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/Confirmations/Loader';

const ApproverListModal = (props) => {
    const { t } = useTranslation();

    const handleClose = () => {
        props.setOpenApproverListModal(false);
    };

    return (
        <>
            <Dialog
                open={props.openApproverListModal}
                fullWidth={true}
                maxWidth={'md'}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle className="items-center">
                    <Grid item xs={12} align="center">
                        <Grid item xs={12}>
                            <Typography
                                variant="caption"
                                className="font-Bosch_sans_light text-[22px] font-semibold"
                            >
                                {props.approverGroupName}
                            </Typography>
                            <IconButton
                                className="boschicon-bosch-ic-close text-2xl absolute top-2 right-2 color-black"
                                aria-label="close"
                                onClick={handleClose}
                            ></IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className='max-h-96 overflow-y-auto'>
                    {props.loaderApproverListModal ? (
                        <div className='h-96'>
                            <Loader customStyle="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                        </div>
                    ) : (
                        <>
                            <hr></hr>
                            {/* Display when an API call error occur   */}
                            {props.errorApproverListCall && (
                                <Typography className="font-Bosch_sans_light text-xl my-20 text-center pl-3 pr-3 ">
                                    {t('ui_spear.ticketDetails.TicketJourney.Error_approver_list')}
                                </Typography>
                            )}
                            {/* Display when approver list is empty   */}
                            {(props.approverList.length == 0 && !props.errorApproverListCall) && (
                                <Typography className="font-Bosch_sans_light text-xl my-20 text-center pl-3 pr-3 ">
                                    {t('ui_spear.ticketDetails.TicketJourney.Approver_list_empty')}
                                </Typography>
                            )}
                            {/* Display approver list  */}
                            {(props.approverList.length > 0 && !props.errorApproverListCall) && (
                                <Typography className="font-Bosch_sans text-lg text-left pl-3 pr-3">
                                    <ul className="flex flex-col">
                                        {props.approverList.map((member) => (
                                            <li className={`pl-4 py-3`} key={member['user.email']}>
                                                <span
                                                    className={`boschicon-bosch-ic-user text-[20px] font-semibold mr-2 text-gray-500`}
                                                ></span> {member['user.u_display_name']}
                                            </li>
                                        ))}
                                    </ul>
                                </Typography>
                            )}
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

//

export default ApproverListModal;